package com.parmartechnologies.storage.collection

import com.parmartechnologies.core.feature.address.model.Address
import com.parmartechnologies.core.feature.auth.model.FriendlyUser
import com.parmartechnologies.core.feature.business.model.Business
import com.parmartechnologies.core.feature.businessConfig.model.BusinessConfig
import com.parmartechnologies.core.feature.businessConnection.model.BusinessConnection
import com.parmartechnologies.core.feature.businessType.model.BusinessType
import com.parmartechnologies.core.feature.cart.model.CartItem
import com.parmartechnologies.core.feature.chat.conversation.model.Conversation
import com.parmartechnologies.core.feature.chat.message.model.Message
import com.parmartechnologies.core.feature.currency.model.Currency
import com.parmartechnologies.core.feature.customer.model.Customer
import com.parmartechnologies.core.feature.employee.model.Employee
import com.parmartechnologies.core.feature.inventory.barCode.model.BarCode
import com.parmartechnologies.core.feature.inventory.brand.model.Brand
import com.parmartechnologies.core.feature.inventory.color.model.ProductColor
import com.parmartechnologies.core.feature.inventory.coupon.model.Coupon
import com.parmartechnologies.core.feature.inventory.discount.model.Discount
import com.parmartechnologies.core.feature.inventory.inventory.model.Inventory
import com.parmartechnologies.core.feature.inventory.model.model.ProductModel
import com.parmartechnologies.core.feature.inventory.offers.model.ProductOffer
import com.parmartechnologies.core.feature.inventory.size.model.Size
import com.parmartechnologies.core.feature.inventory.tag.model.Tag
import com.parmartechnologies.core.feature.inventory.uom.model.UOM
import com.parmartechnologies.core.feature.invoice.model.CustomerInvoice
import com.parmartechnologies.core.feature.mediaFile.model.MediaFile
import com.parmartechnologies.core.feature.offerBanner.model.OfferBanner
import com.parmartechnologies.core.feature.order.model.Order
import com.parmartechnologies.core.feature.product.model.Product
import com.parmartechnologies.core.feature.productCategory.model.ProductCategory
import com.parmartechnologies.core.feature.productSubCategory.model.ProductSubCategory
import com.parmartechnologies.core.feature.profile.model.Profile
import com.parmartechnologies.storage.database.AppDatabase
import com.parmartechnologies.storage.database.DatabaseConfig
import kotlinx.serialization.KSerializer
import kotlinx.serialization.descriptors.elementNames

class DatabaseCollectionConfig {
    companion object {
        private var instance: DatabaseCollectionConfig? = null
        fun shared(): DatabaseCollectionConfig {
            if (instance != null) {
                return instance as DatabaseCollectionConfig
            } else {
                instance = DatabaseCollectionConfig()
                return instance!!
            }
        }
    }
    val allCollectionKeys : MutableMap<String,MutableList<String>> = mutableMapOf()

    fun getAllCollectionName():MutableList<String>{
        val allCollectionNames : MutableList<String> = mutableListOf()
        allCollectionNames.add(getCollectionName(Address.serializer()))
        allCollectionNames.add(getCollectionName(Business.serializer()))
        allCollectionNames.add(getCollectionName(BusinessConfig.serializer()))
        allCollectionNames.add(getCollectionName(BusinessConnection.serializer()))
        allCollectionNames.add(getCollectionName(BusinessType.serializer()))
        allCollectionNames.add(getCollectionName(CartItem.serializer()))
        allCollectionNames.add(getCollectionName(Conversation.serializer()))
        allCollectionNames.add(getCollectionName(Message.serializer()))
        allCollectionNames.add(getCollectionName(Currency.serializer()))
        allCollectionNames.add(getCollectionName(Customer.serializer()))
        allCollectionNames.add(getCollectionName(MediaFile.serializer()))
        allCollectionNames.add(getCollectionName(OfferBanner.serializer()))
        allCollectionNames.add(getCollectionName(Order.serializer()))
        allCollectionNames.add(getCollectionName(Profile.serializer()))
        allCollectionNames.add(getCollectionName(FriendlyUser.serializer()))
        allCollectionNames.add(getCollectionName(CustomerInvoice.serializer()))
        allCollectionNames.add(getCollectionName(Employee.serializer()))
        allCollectionNames.add(getCollectionName(CartItem.serializer()))
        //Inventory
        allCollectionNames.add(getCollectionName(Product.serializer()))
        allCollectionNames.add(getCollectionName(ProductCategory.serializer()))
        allCollectionNames.add(getCollectionName(ProductSubCategory.serializer()))
        allCollectionNames.add(getCollectionName(Inventory.serializer()))
        allCollectionNames.add(getCollectionName(BarCode.serializer()))
        allCollectionNames.add(getCollectionName(Brand.serializer()))
        allCollectionNames.add(getCollectionName(Brand.serializer()))
        allCollectionNames.add(getCollectionName(ProductColor.serializer()))
        allCollectionNames.add(getCollectionName(Coupon.serializer()))
        allCollectionNames.add(getCollectionName(Discount.serializer()))
        allCollectionNames.add(getCollectionName(ProductModel.serializer()))
        allCollectionNames.add(getCollectionName(ProductOffer.serializer()))
        allCollectionNames.add(getCollectionName(Size.serializer()))
        allCollectionNames.add(getCollectionName(Tag.serializer()))
        allCollectionNames.add(getCollectionName(UOM.serializer()))

        return allCollectionNames
    }

    fun <T>getCollectionName(serializer: KSerializer<T>):String{
        var name = ""
        val serialName = serializer.descriptor.serialName.split(".").last()
        if(serialName.isNotEmpty()){
            return serialName
        }else if(serializer.descriptor.serialName.isNotEmpty()){
            return serializer.descriptor.serialName
        }else{
            return "Sample collection"
        }
    }
}